import { render, staticRenderFns } from "./ChannelTypeIcons.vue?vue&type=template&id=13c756fa&"
import script from "./ChannelTypeIcons.vue?vue&type=script&lang=js&"
export * from "./ChannelTypeIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports